import { SRGBColorSpace, MeshBasicMaterial, Mesh, PlaneGeometry, Group, LinearFilter, LinearMipmapLinearFilter, ClampToEdgeWrapping } from "three";
import VaultHero from "./VaultHero";
import gsap from "gsap";

export default class BackgroundShapes {
    constructor() {
        this.experience = new VaultHero()
        this.sizes = this.experience.sizes
        this.scene = this.experience.scene
        this.resources = this.experience.resources

        this.atlasSource = [{
            filename: "itv_shape_1",
            frame: {"x": 0, "y": 3289, "w": 1464, "h": 537},
            size: {width: 732, height: 268},
            position: {x: 474, y: 360},
            positionInit: {x: 0, y: -200}
        }, {
            filename: "itv_shape_2",
            frame: {"x": 1316, "y": 0, "w": 1216, "h": 867},
            size: {width: 608, height: 433},
            position: {x: 100, y: -50},
            positionInit: {x: 40, y: 100},
            rotationInit: 1
        }, {
            filename: "itv_shape_3",
            frame: {"x": 2115, "y": 1900, "w": 402, "h": 1388},
            size: {width: 201, height: 694},
            position: {x: 1550, y: -100},
            positionInit: {x: 240, y: 100},
        }, {
            filename: "itv_shape_4",
            frame: {"x": 2533, "y": 1626, "w": 838, "h": 299},
            size: {width: 419, height: 150},
            position: {x: -30, y: -30},
            positionInit: {x: -100, y: 40},
        }, {
            filename: "itv_shape_5",
            frame: {"x": 1465, "y": 3289, "w": 932, "h": 512},
            size: {width: 466, height: 256},
            position: {x: 1065, y: -65},
            positionInit: {x: 0, y: 100},
        }, {
            filename: "itv_shape_6",
            frame: {"x": 2533, "y": 1041, "w": 805, "h": 584},
            size: {width: 402, height: 292},
            position: {x: 0, y: 335},
            positionInit: {x: -100, y: -50},
        }, {
            filename: "itv_shape_7",
            frame: {"x": 2398, "y": 3289, "w": 1062, "h": 363},
            size: {width: 531, height: 182},
            position: {x: 1150, y: -60},
            positionInit: {x: 50, y: -100},
        }, {
            filename: "itv_shape_8",
            frame: {"x": 0, "y": 3827, "w": 1801, "h": 1388},
            size: {width: 900, height: 694},
            position: {x: 850, y: 0},
            positionInit: {x: 0, y: 100},
        }, {
            filename: "itv_shape_9",
            frame: {"x": 2533, "y": 1926, "w": 898, "h": 554},
            size: {width: 449, height: 277},
            position: {x: 230, y: -50},
            positionInit: {x: -60, y: 200},
            rotationInit: 1
        }, {
            filename: "itv_shape_10",
            frame: {"x": 0, "y": 583, "w": 1315, "h": 1316},
            size: {width: 658, height: 658},
            position: {x: 1050, y: -60},
            positionInit: {x: 250, y: -20},
        }, {
            filename: "itv_shape_11",
            frame: {"x": 1802, "y": 3827, "w": 1609, "h": 1388},
            size: {width: 805, height: 694},
            position: {x: 0, y: -70},
            positionInit: {x: -150, y: -50},
            rotationInit: -2
        }, {
            filename: "itv_shape_12",
            frame: {"x": 0, "y": 0, "w": 667, "h": 582},
            size: {width: 333, height: 291},
            position: {x: 420, y: -60},
            positionInit: {x: 50, y: 100},
            rotationInit: 2
        }, {
            filename: "itv_shape_13",
            frame: {"x": 1316, "y": 868, "w": 994, "h": 993},
            size: {width: 497, height: 496},
            position: {x: 1250, y: 0},
            positionInit: {x: 200, y: 30},
        }, {
            filename: "itv_shape_14",
            frame: {"x": 2533, "y": 2481, "w": 603, "h": 603},
            size: {width: 301, height: 301},
            position: {x: 1450, y: -70},
            positionInit: {x: -100, y: 0},
        }, {
            filename: "itv_shape_15",
            frame: {"x": 2533, "y": 0, "w": 1040, "h": 1040},
            size: {width: 520, height: 520},
            position: {x: -60, y: 0},
            positionInit: {x: -200, y: 150},
            rotationInit: -0.5
        }, {
            filename: "itv_shape_16",
            frame: {"x": 0, "y": 1900, "w": 2114, "h": 1388},
            size: {width: 1057, height: 694},
            position: {x: 110, y: -50},
            positionInit: {x: 100, y: 0},
        }]

        // revert the order of the shapes
        this.atlasSource.reverse();

        this.meshes = [];

        this.backgroundShapes = new Group();

        this.setShapes()

        this.sizes.fitToScene(this.backgroundShapes)

        this.appearAnimation()
    }

    calcPosition(spriteData) {
        const position = spriteData.position;
        const width = spriteData.size.width;
        const height = spriteData.size.height;

        let x = (position.x + width / 2) - this.sizes.originalWidth / 2;
        let y = -(position.y + height / 2) + this.sizes.originalHeight / 2;

        x *= this.sizes.rem;
        y *= this.sizes.rem;

        return {x, y};
    }

    setShapes() {
        for (let i = 0; i < this.atlasSource.length; i++) {
            let spriteData = this.atlasSource[i];
            const position = this.calcPosition(spriteData);
            const shapeWidth = spriteData.size.width * this.sizes.rem;
            const shapeHeight = spriteData.size.height * this.sizes.rem;
            const geometry = new PlaneGeometry(shapeWidth, shapeHeight, 1, 1);

            const texture = this.resources.items[spriteData.filename];
            texture.colorSpace = SRGBColorSpace;
            texture.generateMipmaps = true;
            texture.minFilter = LinearMipmapLinearFilter;
            texture.magFilter = LinearFilter;
            texture.wrapS = ClampToEdgeWrapping;
            texture.wrapT = ClampToEdgeWrapping;
            
            // Apply anisotropic filtering if available
            if (this.experience.renderer.maxAnisotropy) {
                texture.anisotropy = this.experience.renderer.maxAnisotropy;
            }

            const material = new MeshBasicMaterial({
                map: texture,
                transparent: true,
                depthTest: false,
                depthWrite: false,
                premultipliedAlpha: true
            });

            const mesh = new Mesh(geometry, material);
            mesh.position.set(position.x, position.y, 0);
            mesh.customData = spriteData

            this.meshes.push(mesh);
            this.backgroundShapes.add(mesh);
        }

        this.scene.add(this.backgroundShapes);
    }

    appearAnimation() {
        const timeline = gsap.timeline();

        const toAnimate = this.meshes.filter((mesh) => {
            const spriteData = mesh.customData;
            return spriteData.positionInit !== undefined;
        })


        toAnimate.forEach((mesh, index) => {
            const spriteData = mesh.customData;
            const positionInit = {
                x: spriteData.positionInit.x * this.sizes.rem,
                y: spriteData.positionInit.y * this.sizes.rem
            };
            const rotationInit = spriteData.rotationInit || 0;

            timeline.from(mesh.material, {
                opacity: 0,
                duration: 2,
                ease: "power3.out",
            }, index * 0.15)

            timeline.from(mesh.position, {
                x: `+=${positionInit.x}`,
                y: `+=${positionInit.y}`,
                duration: 2,
                ease: "power3.out",
            }, index * 0.15)

            if (rotationInit !== 0) {
                timeline.from(mesh.rotation, {
                    z: rotationInit,
                    duration: 2,
                    ease: "power3.out",
                }, index * 0.15)
            }
        })
    }

    resize() {
        this.sizes.fitToScene(this.backgroundShapes)
    }
}
